import React from 'react';
import PropTypes from 'prop-types';
import { Title } from 'web-ui-components/lib/atoms/text';
import { default as content } from '../AddNewPayeeLandingPage/index.content';
import BankAddressDetails from './BankAddressDetails';
import { PayeeAccountTypeSelect } from './PayeeAccountTypeComponent';
import {
	validationPropsProtoTypes,
	ibanFieldPropTypes,
	internationalAccountNumberFieldPropTypes,
	paymentReasonFieldPropTypes,
	bickOrSwiftFieldPropTypes,
	clearingCodeFieldPropTypes,
	bankNameFieldPropTypes,
} from '../../states/addPayee/propTypes';
import { PaymentReasonTextArea } from './withValidationComponents';
import { addPayeeFormLengths } from '../../../config';
import { default as IFTcontent } from '../../../ift/components/IFTPaymentDetails/PaymentsReasonSection/PaymentsReasonSection.content';
import { swiftMultiChar } from '../../../containers/withValidation';

const PaymentDetailsForm = ({
	validationProps,
	iban,
	internationalAccountNumber,
	payeeAccountType,
	paymentReason,
	bickOrSwift,
	clearingCode,
	noBicOrSwift,
	noBicOrSwiftChange,
	bankAddressLine1,
	bankAddressLine2,
	bankCity,
	bankPostalCode,
	bankCountry,
	bankName,
	payeeAccountChange,
}) => {
	const { paymentDetailsTitle, paymentReasonLabel, paymentReasonDescription } = content;
	const { invalidReasonWarning } = IFTcontent;
	const showBankDetails = payeeAccountType === 'accono' && noBicOrSwift;
	return (
		<span>
			<Title size="h2">{paymentDetailsTitle}</Title>
			<PayeeAccountTypeSelect
				id="payeeAccountType"
				iban={iban}
				value={payeeAccountType}
				validationProps={validationProps}
				payeeAccountType={payeeAccountType}
				internationalAccountNumber={internationalAccountNumber}
				bickOrSwift={bickOrSwift}
				clearingCode={clearingCode}
				noBicOrSwift={noBicOrSwift}
				noBicOrSwiftChange={noBicOrSwiftChange}
				payeeAccountChange={payeeAccountChange}
				{...validationProps}
			/>
			<PaymentReasonTextArea
				{...validationProps}
				{...paymentReason}
				label={paymentReasonLabel}
				description={paymentReasonDescription}
				onChange={({ value }) => validationProps.onChange({ target: { value, id: paymentReason.id } })}
				maximumCharacters={addPayeeFormLengths.paymentReason}
				useValidation={!swiftMultiChar(paymentReason.value)}
				errorMessage={invalidReasonWarning}
			/>
			<BankAddressDetails
				showBankDetails={showBankDetails}
				validationProps={validationProps}
				bankAddressLine1={bankAddressLine1}
				bankAddressLine2={bankAddressLine2}
				bankCity={bankCity}
				bankPostalCode={bankPostalCode}
				bankCountry={bankCountry}
				bankName={bankName}
				showBankAddress
			/>
		</span>
	);
};

PaymentDetailsForm.propTypes = {
	validationProps: PropTypes.shape(validationPropsProtoTypes).isRequired,
	iban: PropTypes.shape(ibanFieldPropTypes).isRequired,
	internationalAccountNumber: PropTypes.shape(internationalAccountNumberFieldPropTypes).isRequired,
	payeeAccountType: PropTypes.string,
	paymentReason: PropTypes.shape(paymentReasonFieldPropTypes).isRequired,
	bickOrSwift: PropTypes.shape(bickOrSwiftFieldPropTypes).isRequired,
	clearingCode: PropTypes.shape(clearingCodeFieldPropTypes).isRequired,
	noBicOrSwift: PropTypes.bool,
	noBicOrSwiftChange: PropTypes.func.isRequired,
	bankAddressLine1: PropTypes.string,
	bankAddressLine2: PropTypes.string,
	bankCity: PropTypes.string,
	bankPostalCode: PropTypes.string,
	bankCountry: PropTypes.string,
	bankName: PropTypes.shape(bankNameFieldPropTypes).isRequired,
	payeeAccountChange: PropTypes.func.isRequired,
};

export default PaymentDetailsForm;
